import { IApplicationState } from '../../types/redux';
import { IFilters } from '../../types/filters';

export function selectFilters(state: IApplicationState): IFilters {
  const { filters } = state;

  return filters;
}
